export const GET_OVERVIEW_SEARCH_REQUEST = "GET_OVERVIEW_SEARCH_REQUEST";
export const GET_OVERVIEW_SEARCH_SUCCESS = "GET_OVERVIEW_SEARCH_SUCCESS";
export const GET_OVERVIEW_SEARCH_FAILURE = "GET_OVERVIEW_SEARCH_FAILURE";
export const CLEAR_OVERVIEW_SEARCH = "CLEAR_OVERVIEW_SEARCH";
